/**
 * useMobileBanner Hook
 * Simple hook to control which mobile banner is displayed on a page
 * Automatically resets to default when component unmounts
 */

import { useEffect } from 'react';
import { useNavigation } from '../components/context/NavigationContext';

/**
 * @param {string} bannerType - Type of banner to show:
 *   - 'default' - Default banner with hamburger, tier, star coins
 *   - 'homepage' - Custom homepage banner with tour button
 *   - 'chat' - MobileTopBanner for chat interface
 *   - 'none' - No banner
 *   - Any custom string for future custom banners
 */
export const useMobileBanner = (bannerType = 'default') => {
  const { setMobileBannerComponent, setInChatInterface } = useNavigation();

  useEffect(() => {
    // Set the banner type
    setMobileBannerComponent(bannerType);

    // Also hide the floating hamburger if showing any banner
    if (bannerType !== 'none') {
      setInChatInterface(true); // This hides the floating hamburger
    }

    // Cleanup: reset to default when leaving the page
    return () => {
      setMobileBannerComponent('default');
      setInChatInterface(false); // Re-enable floating hamburger
    };
  }, [bannerType, setMobileBannerComponent, setInChatInterface]);
};

export default useMobileBanner;